import { render, staticRenderFns } from "./HtmlReading.vue?vue&type=template&id=34132649&scoped=true"
import script from "./HtmlReading.vue?vue&type=script&lang=js"
export * from "./HtmlReading.vue?vue&type=script&lang=js"
import style0 from "./HtmlReading.vue?vue&type=style&index=0&id=34132649&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34132649",
  null
  
)

export default component.exports